/**
 *  错误信息
 *
 *  此文件为自动生成，请不要修改！
 *
 *  生成日期: Wed Feb 08 14:23:07 CST 2023
 */

const getErrorMsg = (function () {
  let errorMsg = [];

  errorMsg["n-1"] = '系統异常，請稍後重試';  //UNKNOWN
  errorMsg["n0"] = 'success';  //SUCCESS
  errorMsg["n304"] = '系統异常，請稍後重試';  //NOT_MODIFIED
  errorMsg["n400"] = '系統异常，請稍後重試';  //BAD_REQUEST
  errorMsg["n401"] = '您當前狀態已失效，請重新登入！';  //UNAUTHORIZED
  errorMsg["n403"] = '禁止訪問';  //FORBIDDEN
  errorMsg["n404"] = 'Not Found';  //NOT_FOUND
  errorMsg["n405"] = '系統异常，請稍後重試';  //METHOD_NOT_ALLOWED
  errorMsg["n406"] = '系統异常，請稍後重試';  //NOT_ACCEPTABLE
  errorMsg["n407"] = '系統异常，請稍後重試';  //PROXY_AUTHENTICATION_REQUIRED
  errorMsg["n408"] = '系統异常，請稍後重試';  //REQUEST_TIMEOUT
  errorMsg["n412"] = '系統异常，請稍後重試';  //PRECONDITION_FAILED
  errorMsg["n413"] = '系統异常，請稍後重試';  //PAYLOAD_TOO_LARGE
  errorMsg["n415"] = '系統异常，請稍後重試';  //UNSUPPORTED_MEDIA_TYPE
  errorMsg["n417"] = '系統异常，請稍後重試';  //EXPECTATION_FAILED
  errorMsg["n422"] = '必須的參數未傳入！';  //PARAM_BUILDING_ERROR
  errorMsg["n423"] = '系統异常，請稍後重試';  //LOCKED
  errorMsg["n424"] = '系統异常，請稍後重試';  //FAILED_DEPENDENCY
  errorMsg["n426"] = '系統异常，請稍後重試';  //UPGRADE_REQUIRED
  errorMsg["n429"] = '系統异常，請稍後重試';  //TOO_MANY_REQUESTS
  errorMsg["n500"] = '系統异常，請稍後重試！';  //INTERNAL_SERVER_ERROR
  errorMsg["n501"] = '系統异常，請稍後重試';  //NOT_IMPLEMENTED
  errorMsg["n503"] = '系統异常，請稍後重試';  //SERVICE_UNAVAILABLE
  errorMsg["n510"] = '系統异常，請稍後重試';  //NOT_EXTENDED
  errorMsg["n511"] = '系統异常，請稍後重試';  //NETWORK_AUTHENTICATION_REQUIRED
  errorMsg["n901"] = '系統异常，請稍後重試';  //UDR_INVALID_DATA
  errorMsg["n991"] = '系統异常，請稍後重試';  //DB_DATA_ACCESS
  errorMsg["n998"] = '系統异常，請稍後重試';  //DB_DATA_INTEGRITY_VIOLATION
  errorMsg["n999"] = '系統异常，請稍後重試';  //UNIQ_KEY_ERROR
  errorMsg["n1000"] = '系統錯誤，請聯系管理員！';  //MAX_HARD_CODE
  errorMsg["n1001"] = '郵箱規格不存在';  //MA_NO_SPEC
  errorMsg["n1002"] = '郵箱帳號或者列表已經存在';  //MA_ACCOUNT_EXIST
  errorMsg["n1003"] = '父部門不存在';  //MA_PARENT_DEPT_NOT_EXIST
  errorMsg["n1004"] = '有不存在的部門id';  //MA_DEPT_IDS_NOT_EXIST
  errorMsg["n1005"] = '父部門id不能設定成自己的子部門id';  //MA_PARENT_DEPT_NOT_PROMIT
  errorMsg["n1006"] = '存在子部門不允許删除';  //MA_DEL_DEPT_NOT_PROMIT
  errorMsg["n1007"] = '部門存在人員不允許删除';  //MA_DEL_DEPT_MEM_NOT_PROMIT
  errorMsg["n1008"] = '企業不存在此域名';  //MA_CORP_DOMAIN_NOT_EXIST
  errorMsg["n1009"] = '郵箱帳號或者列表不存在';  //MA_ACCOUNT_NOT_EXIST
  errorMsg["n1010"] = '主郵箱帳號不存在';  //MA_ACCOUNT_PRIME_NOT_EXIST
  errorMsg["n1011"] = '別名個數超出限制';  //MA_OVER_ALIAS_COUNT
  errorMsg["n1012"] = '別名不存在';  //MA_ALIAS_NOT_EXIST
  errorMsg["n1013"] = '通訊錄不存在';  //MA_CONTACT_NOT_EXIST
  errorMsg["n1014"] = '父通訊錄不存在';  //MA_PARENT_CONTACT_NOT_EXIST
  errorMsg["n1015"] = '存在子部門不允許删除';  //MA_DEL_CONTACT_NOT_PROMIT
  errorMsg["n1016"] = '存在通訊錄信息不允許删除';  //MA_DEL_CONTACT_INFO_NOT_PROMIT
  errorMsg["n1017"] = '父通訊錄id不能設定成自己的子通訊錄id';  //MA_PARENT_CONTACT_NOT_PROMIT
  errorMsg["n1018"] = '企業不存在';  //MA_CORP_NOT_EXIST
  errorMsg["n1019"] = '企業id不存在';  //MA_CORP_ID_NOT_EXIST
  errorMsg["n1020"] = '郵箱規格不存在';  //MA_SPEC_NOT_EXIST
  errorMsg["n1021"] = '添加部門錯誤';  //MA_ADD_DEPART_ERROR
  errorMsg["n1022"] = '此規則不存在';  //MA_RULE_NOT_EXIST
  errorMsg["n1023"] = '部門id為空';  //MA_CORPID_DEPARTID_NULL
  errorMsg["n1024"] = '部門下存在用戶不允許删除';  //MA_DEL_DEPART_USER_EXIST
  errorMsg["n1025"] = '用戶不存在';  //MA_USER_NOT_EXIST
  errorMsg["n1026"] = '登入時間限制參數不完整';  //MA_LOGIN_RULE_TIME_ERROR
  errorMsg["n1027"] = '登入限制規則不存在';  //MA_LOGIN_RULE_NOT_EXIST
  errorMsg["n1028"] = '登入限制規則已存在';  //MA_LOGIN_RULE_EXIST
  errorMsg["n1029"] = '郵箱規格關聯了{}個企業，請先修改關聯企業的郵箱規格。';  //MA_SPEC_BE_USED
  errorMsg["n1030"] = '黑白名單不存在';  //MA_BLACK_WHITE_LIST_NOT_EXIST
  errorMsg["n1031"] = '默認管理員权限组不允許修改';  //MA_PRIVILEGE_NOT_ALLOW_UPDATE
  errorMsg["n1032"] = '管理員权限组不存在';  //MA_PRIVILEGE_NOT_EXIST
  errorMsg["n1033"] = '企業域名已存在';  //MA_CORP_DOMAIN_EXIST
  errorMsg["n1034"] = '默認郵箱規則不允許删除';  //MA_SPEC_IS_DEFAULT
  errorMsg["n1035"] = '上傳文件失敗';  //MA_UPLOAD_FILE_FAIL
  errorMsg["n1036"] = '企業不存在主域名';  //MA_CORP_DOMAIN_NAME_NOT_EXIST
  errorMsg["n1037"] = '歡迎信已經存在，不能重複添加';  //MA_CORP_WELCOME_EMAIL_EXIST
  errorMsg["n1038"] = '歡迎信不存在';  //MA_CORP_WELCOME_EMAIL_NOT_EXIST
  errorMsg["n1039"] = '企業域名已經存在';  //MA_DOMAIN_ALREADY_EXIST
  errorMsg["n1040"] = 'API帳號不存在';  //MA_API_NOT_EXIST
  errorMsg["n1041"] = '本企業API規則已經存在，不能重複添加';  //MA_API_EXIST
  errorMsg["n1042"] = '企業主域名已經存在';  //MA_MAIN_DOMAIN_ALREADY_EXIST
  errorMsg["n1043"] = '域名下還有用戶存在';  //MA_DOMAIN_USER_EXIST
  errorMsg["n1044"] = '企業主域名不能删除';  //MA_MAIN_DOMAIN_NOT_DELETE
  errorMsg["n1045"] = '企業域名不存在';  //MA_DOMAIN_NOT_EXIST
  errorMsg["n1046"] = '企業默認域名不存在';  //MA_DEFAULT_DOMAIN_NOT_EXIST
  errorMsg["n1047"] = '郵箱規格名稱重複';  //MA_SPEC_NAME_EXIST
  errorMsg["n1048"] = '郵箱規格有關聯用戶，不允許删除';  //MA_SPEC_USER_USED
  errorMsg["n1049"] = '系統帳號不允許禁用或删除';  //MA_SYS_ACCOUNT_NOT_DELETE
  errorMsg["n1050"] = '郵箱規格最大空間不存在';  //MA_SPEC_MAX_SPACE_NOT_EXIST
  errorMsg["n1051"] = '新密碼不能與原密碼相同';  //MA_PASSWORD_SAME_ERROR
  errorMsg["n1052"] = '郵箱最大空間數過小';  //MA_MAX_SPACE_ERROR
  errorMsg["n1053"] = '企業人數超出最大限制，不允許添加用戶';  //MA_CORP_USER_EXCEEDED_ERROR
  errorMsg["n1054"] = '默認管理員不允許編輯';  //MA_MANAGER_ADMIN_CANT_NOT_MODIFY
  errorMsg["n1055"] = '默認管理員不允許删除';  //MA_MANAGER_ADMIN_CANT_NOT_DELETE
  errorMsg["n1056"] = '沒有許可權操作此权限组';  //MA_NO_PERMISSION_MODIFY_PRIVILEGE
  errorMsg["n1057"] = '此权限组有關聯用戶，禁止删除';  //MA_PRIVILEGE_BE_USED
  errorMsg["n1058"] = '域名解析未驗證成功，請核對解析記錄';  //MA_DOMAIN_MX_VALIDATE_FAILED
  errorMsg["n1059"] = '批量任務Id不能為空';  //MA_TASK_ID_NOT_EXIST
  errorMsg["n1060"] = '企業視圖不存在';  //MA_CORP_VIEW_NOT_EXIST
  errorMsg["n1061"] = '默認企業視圖不允許删除';  //MA_CORP_VIEW_IS_DEF
  errorMsg["n1062"] = '視圖成員不能為空';  //MA_CORP_VIEW_USER_IS_NULL
  errorMsg["n1063"] = '郵箱規格最大空間數過小';  //MA_SPEC_MAX_SPACE_ERROR
  errorMsg["n1064"] = '同一級下存在相同部門名';  //MA_DEPT_EXIST_SAME_NAME
  errorMsg["n1065"] = '入職日期格式不正確';  //MA_EXCEL_PARSE_ERROR
  errorMsg["n1067"] = '登入POP服務器失敗';  //MA_POP_TEST_ERROR
  errorMsg["n1068"] = '登入IMAP服務器失敗';  //MA_IMAP_TEST_ERROR
  errorMsg["n1069"] = '郵箱最大空間不能為空';  //MA_MAX_SPACE_IS_NULL
  errorMsg["n1070"] = '密碼錯誤';  //MA_PWD_ERROR
  errorMsg["n1071"] = '管理員权限组名稱已經存在';  //MA_PRIVILEGE_IS_EXIST
  errorMsg["n1072"] = '視圖成員中存在非本企業域帳號';  //MA_DOMAIN_IS_OTHERS
  errorMsg["n1073"] = '批量參數不能為空';  //MA_BATCH_PARAM_NOT_EMPTY
  errorMsg["n1074"] = '存在正在執行的批量任務，請稍後重試';  //MA_BATCH_TASK_LOCK_EXIST
  errorMsg["n1075"] = 'excel部門路徑過長';  //MA_BATCH_DEPTPATH_TOOLONG
  errorMsg["n1076"] = '部門層級過多';  //MA_DEPT_OVER_DEEP
  errorMsg["n1077"] = '部門名稱不合法';  //MA_DEPT_NAME_INVALID
  errorMsg["n1078"] = '必填用戶郵箱不合法';  //MA_USER_EMAIL_INVALID
  errorMsg["n1079"] = '必填用戶姓名不合法';  //MA_USER_NAME_INVALID
  errorMsg["n1080"] = '用戶手機不合法';  //MA_USER_MOBILE_INVALID
  errorMsg["n1081"] = '用戶座機不合法';  //MA_USER_TEL_INVALID
  errorMsg["n1082"] = '用戶傳真不合法';  //MA_USER_FAX_INVALID
  errorMsg["n1083"] = '用戶備註不合法';  //MA_USER_MEMO_INVALID
  errorMsg["n1084"] = '用戶員工編號不合法';  //MA_USER_EMPLOYEEID_INVALID
  errorMsg["n1085"] = '用戶職位不合法';  //MA_USER_POSITION_INVALID
  errorMsg["n1086"] = '用戶範圍帳號信息不能為空';  //MA_USER_SCOPE_ACCOUNT_CANNOT_EMPTY
  errorMsg["n1087"] = '不合法的範本類型';  //MA_INVALID_TEPMLATE_TYPE
  errorMsg["n1088"] = '郵箱規格填寫錯誤';  //MA_BATCH_SPEC_ERROR
  errorMsg["n1089"] = 'excel文件中的數量超限';  //MA_BATCH_TASK_OVER_LIMIT
  errorMsg["n1090"] = '此地址已經存在黑名單';  //MA_BLACK_EXIST
  errorMsg["n1091"] = '定期修改密碼週期必須大於0';  //MA_RULE_PWD_CYCLE
  errorMsg["n1092"] = '提醒週期不能大於或等於密碼修改週期';  //MA_RULE_PWD_BEFORE
  errorMsg["n1093"] = '提醒頻率不能大於或等於提醒週期';  //MA_RULE_PWD_REMIND
  errorMsg["n1094"] = 'API帳號名稱重複';  //MA_API_IS_EXIST
  errorMsg["n1095"] = '部門描述不合法';  //MA_DEPT_MEMO_INVALID
  errorMsg["n1096"] = '审核名稱已經存在';  //MA_AUDIT_NAME_EXIST
  errorMsg["n1097"] = '分類過濾名稱已經存在';  //MA_FILTER_NAME_EXIST
  errorMsg["n1098"] = '存在相同名稱的規則';  //MA_RULE_SAME_NAME
  errorMsg["n1099"] = '存在相同名稱的api';  //MA_API_SAME_NAME
  errorMsg["n1100"] = '部門不存在';  //MA_DEPT_NOT_EXIST
  errorMsg["n1101"] = '地址填寫有誤，不支持填寫郵箱別名、輔域名';  //MA_MEMBER_CORRECT_ERROR
  errorMsg["n1102"] = '域名數量超過上限';  //MA_DOMAIN_COUNT_OVERFLOW
  errorMsg["n1103"] = '企業最大人數過小';  //MA_CORP_USER_NUM_SMALL
  errorMsg["n1104"] = '證書過期';  //MA_LICENSE_EXPIRED
  errorMsg["n1105"] = '不允許删除自己';  //MA_MANAGER_NOT_DELETE_SELF
  errorMsg["n1106"] = '不允許修改自己';  //MA_MANAGER_NOT_UPDATE_SELF
  errorMsg["n1107"] = '管理員已經存在';  //MA_PRIVILEGE_EXIST
  errorMsg["n1108"] = '禁止發送外域';  //MA_EXIST_FOREIGN_DOMAIN
  errorMsg["n1109"] = '嵌套列表存在死迴圈';  //MA_END_LESS_LOOP_LIST
  errorMsg["n1110"] = '嵌套列表不存在';  //MA_MAIL_LIST_NOT_EXIST
  errorMsg["n1111"] = '主域名信息不能為空';  //MA_MAIN_DOMAIN_NOT_NULL
  errorMsg["n1112"] = '审核人不存在';  //MA_AUDITOR_ERROR
  errorMsg["n1113"] = 'ms存审核索引報錯';  //MA_AUDIT_MS_INDEX_ERROR
  errorMsg["n1114"] = '填寫本企業下的主名郵箱地址';  //MA_CORP_MAIL_DEL_EMAIL_INVALID
  errorMsg["n1115"] = '視圖範圍僅支持填寫本企業下的主名郵箱地址';  //MA_EMAIL_IS_OTHERS
  errorMsg["n1116"] = '审核原信解析失敗';  //MA_AUDIT_MS_ERROR
  errorMsg["n1117"] = '审核人不存在';  //MA_AUDIT_AUDITOR_ERROR
  errorMsg["n1118"] = '审核原信解析失敗';  //MA_AUDIT_MIME_ERROR
  errorMsg["n1119"] = '操作成功';  //MA_MANAGER_LOG_SUCCESS
  errorMsg["n1120"] = '操作失敗';  //MA_MANAGER_LOG_ERROR
  errorMsg["n1121"] = '企業空間超出最大限制';  //MA_CORP_USER_SPACE_ERROR
  errorMsg["n1122"] = '管理員不能對自己進行操作，如果需要請聯系上級管理員。';  //MA_CORP_MANAGER_NOT_DEL
  errorMsg["n1123"] = '根節點不允許删除';  //MA_TOP_NOT_DEL
  errorMsg["n1124"] = '收件人包含非本企業用戶';  //MA_TO_FOREIGN_DOMAIN
  errorMsg["n1125"] = '此地址已經存在白名單';  //MA_WHITE_EXIST
  errorMsg["n1126"] = '視圖名稱重複';  //MA_CORP_VIEW_EXIST
  errorMsg["n1127"] = '企業人數超過授權人數，請重新輸入或者聯系超級管理員';  //MA_CORP_USER_LIMIT
  errorMsg["n1128"] = '郵箱狀態錯誤';  //MA_MAIL_STATUS_ERROR
  errorMsg["n1129"] = 'IP格式錯誤';  //MA_IP_FORMAT_ERROR
  errorMsg["n1130"] = '用戶id不能為空';  //MA_USER_ID_NULL
  errorMsg["n1131"] = '用戶id不合法';  //MA_USER_ID_ERROR
  errorMsg["n1132"] = '帳戶到期執行動作錯誤';  //MA_EXPIRE_TYPE_ERROR
  errorMsg["n1133"] = '別名重複';  //MA_ALIAS_REPEAT_ERROR
  errorMsg["n1134"] = '外部連絡人群組名稱不能為空';  //MA_GROUP_NAME_NOT_NULL
  errorMsg["n1135"] = '外部連絡人群組不存在';  //MA_GROUP_NOT_EXISTS
  errorMsg["n1136"] = '備份郵箱信息不存在';  //MA_BACKUP_MAIL_ACCOUNT_NOT_EXISTS
  errorMsg["n1137"] = '備份用戶信息不存在';  //MA_BACKUP_USER_INFO_NOT_EXISTS
  errorMsg["n1138"] = '備份郵箱使用情况不存在';  //MA_BACKUP_USER_USED_INFO_NOT_EXISTS
  errorMsg["n2001"] = '郵件不存在';  //WM_READ_MAIL_NOT_EXIST
  errorMsg["n2002"] = '非法請求或郵件連結已經過期';  //WM_READ_MAIL_NON_GARBAGE_MAIL_LINK_EXPIRED
  errorMsg["n2003"] = '此郵件已被移至收件夾，如果您是郵件用戶端用戶，請收取到本地查看';  //WM_READ_MAIL_NON_GARBAGE_MAIL
  errorMsg["n2004"] = '文件夹不存在';  //WM_READ_MAIL_FOLDER_NOT_EXIST
  errorMsg["n2005"] = '操作數據超過最大限制';  //WM_READ_MAX_LIMIT
  errorMsg["n2006"] = '非加密郵件';  //WM_READ_UN_ENCRYPT_MAIL_ERROR
  errorMsg["n2007"] = '加密郵件解密失敗';  //WM_READ_DECRYPT_MAIL_ERROR
  errorMsg["n2008"] = '首次解密，前端未傳入密碼';  //WM_READ_NO_HAS_PASSWORD_ERROR
  errorMsg["n2009"] = '查詢密碼失敗';  //WM_READ_NO_PASSWORD_ERROR
  errorMsg["n2051"] = '發信失敗，請聯系管理員';  //WM_SEND_MAIL_ERROR
  errorMsg["n2052"] = '參數提交异常';  //WM_SEND_MAIL_BUILD_PARAM_ERROR
  errorMsg["n2053"] = '發信地址格式錯誤';  //WM_SEND_MAIL_BUILD_ADDRESS_ERROR
  errorMsg["n2054"] = '發件人超容';  //WM_SEND_MAIL_OVER_SPACE_ERROR
  errorMsg["n2055"] = '發件人已被禁止發信';  //WM_SEND_MAIL_SENDER_FORBID_ERROR
  errorMsg["n2056"] = '收件人數量不能超過{count}個';  //WM_SEND_MAIL_ADDRESS_TO_MAX_LIMIT_ERROR
  errorMsg["n2057"] = '普通附件總大小超過限制';  //WM_SEND_MAIL_ATTACHMENT_MAX_LIMIT_ERROR
  errorMsg["n2058"] = 'postmaster帳號被禁用';  //WM_SEND_MAIL_POSTMASTER_FORBIDDEN_ERROR
  errorMsg["n2059"] = '編輯器內圖片已過期，請重新上傳';  //WM_SEND_MAIL_INNER_FILE_EXPIRE
  errorMsg["n2060"] = '附件文件已過期，請重新上傳';  //WM_SEND_MAIL_ATTACH_FILE_EXPIRE
  errorMsg["n2061"] = '撤回失敗，請稍後重試';  //WM_SEND_UNDO_MAIL_ERROR
  errorMsg["n2062"] = '完成撤回';  //WM_SEND_UNDO_MAIL_EXECUTED_ERROR
  errorMsg["n2063"] = '發件人非本系統郵箱，不支持撤回';  //WM_SEND_UNDO_MAIL_NO_SELF_ERROR
  errorMsg["n2064"] = '撤回失敗，郵件超過{undo_time_limit}或已被收件人删除';  //WM_SEND_UNDO_MAIL_EXPIRED_ERROR
  errorMsg["n2065"] = '撤回失敗，群發單顯加密郵件暫不支持撤回';  //WM_SEND_UNDO_MAIL_SEND_ALONE_ENCRYPT_ERROR
  errorMsg["n2201"] = '附件分片上傳失敗';  //WM_ATTACH_UPLOAD_FAIL
  errorMsg["n2202"] = '內嵌文件上傳失敗';  //WM_INNER_FILE_UPLOAD_FAIL
  errorMsg["n2203"] = '不支持的內嵌文件類型';  //WM_INNER_FILE_CONTENT_TYPE_FAIL
  errorMsg["n2204"] = '內嵌文件太大';  //WM_INNER_FILE_TOO_LARGE_FAIL
  errorMsg["n2205"] = '對不起，您下載次數過於頻繁，請稍後再試';  //WM_ATTACH_DOWNLOAD_FREQUENCY_FAIL
  errorMsg["n2251"] = '最多可創建{sign_max}個郵件簽名';  //WM_MAILACCOUNTSIGN_ERROR
  errorMsg["n2252"] = '內容格式有誤';  //WM_MAILACCOUNTSIGN_SAVE_ERROR
  errorMsg["n2254"] = '新密碼不能與原密碼相同';  //WM_PASSWORD_SAME_ERROR
  errorMsg["n2256"] = '新密碼過於簡單，請重新輸入';  //WM_PASSWORD_SIMPLE_ERROR
  errorMsg["n2257"] = '您輸入的舊密碼有誤';  //WM_PASSWORD_INVALID_ERROR
  errorMsg["n2260"] = '新密碼不符合規則';  //WM_PASSWORD_WEAK_ERROR
  errorMsg["n2301"] = '連絡人已存在';  //WM_CONTACT_ADDUSER_ERROR
  errorMsg["n2302"] = '郵箱格式不符合規範';  //WM_CONTACT_EMAILFORMAT_ERROR
  errorMsg["n2303"] = '匯出連絡人失敗';  //WM_CONTACT_EXPORTCONTACT_ERROR
  errorMsg["n2304"] = '文件格式不符合規範';  //WM_CONTACT_FILEFORMAT_ERROR
  errorMsg["n2305"] = '要導入的連絡人數據為空';  //WM_CONTACT_IMPORTCONTACT_ERROR
  errorMsg["n2306"] = '組名稱已存在';  //WM_CONTACT_GROUPNAME_ERROR
  errorMsg["n2307"] = '個人通訊錄連絡人數量不能超過{contact_max}';  //WM_CONTACT_COUNTMAX_ERROR
  errorMsg["n2308"] = '導入連絡人失敗';  //WM_CONTACT_IMPORT_ERROR
  errorMsg["n2309"] = '未査詢到郵寄列表信息';  //WM_CONTACT_GETEMAILLIST_ERROR
  errorMsg["n2310"] = '主郵箱不可重複添加';  //WM_CONTACT_EMAILREPEAT_ERROR
  errorMsg["n2340"] = '至少有一項不為空';  //WM_CONTACT_NOTNULLITEM_ERROR
  errorMsg["n2341"] = '郵寄列表不存在';  //WM_CONTACT_GETSELECTORID_ERROR
  errorMsg["n2342"] = '導入文件大小超過限制';  //WM_CONTACT_FILEMAX_ERROR
  errorMsg["n2343"] = '暫不支持導入此文件類型';  //WM_CONTACT_FILETYPE_ERROR
  errorMsg["n2344"] = '郵箱最多可添加{user_contact_member_max}條';  //WM_CONTACT_EMAIL_MAX_ERROR
  errorMsg["n2345"] = '電話最多可添加{user_contact_member_max}條';  //WM_CONTACT_TELEPHONE_MAX_ERROR
  errorMsg["n2346"] = '傳真最多可添加{user_contact_member_max}條';  //WM_CONTACT_FAX_MAX_ERROR
  errorMsg["n2351"] = '未査詢到常規設定';  //WM_ACCOUNT_NOSETTING_ERROR
  errorMsg["n2352"] = '修改常規設定失敗';  //WM_ACCOUNT_UPDATE_ERROR
  errorMsg["n2353"] = '默認抄送地址最多可添加{cc_email_max}條';  //WM_ACCOUNT_CC_MAX_ERROR
  errorMsg["n2354"] = '默認密送地址最多可添加{cc_email_max}條';  //WM_ACCOUNT_BCC_MAX_ERROR
  errorMsg["n2401"] = '黑名單最多可添加{black_list_max}條';  //WM_BLACKLIST_MAXCOUNT_ERROR
  errorMsg["n2402"] = '您添加的黑名單已經存在！';  //WM_BLACKLIST_EXICT_ERROR
  errorMsg["n2451"] = '帳號信息不存在';  //WM_AUTHCODE_USERNOTEXIST_ERROR
  errorMsg["n2452"] = '授權碼最多可添加{client_code_max}條';  //WM_AUTHCODE_MAXCOUNT_ERROR
  errorMsg["n2501"] = '未査詢到反垃圾設定';  //WM_ANTISPAM_NODEF_ERROR
  errorMsg["n2502"] = '系統异常，請稍後重試';  //WM_ANTISPAM_SAVEREDIS_ERROR
  errorMsg["n2503"] = '時間不能為空，請設定提醒時間';  //WM_ANTISPAM_REMINDER_ERROR
  errorMsg["n2551"] = 'POP郵箱已存在，請勿重複添加';  //WM_POP_EMAILCOUNT_ERROR
  errorMsg["n2552"] = 'POP郵箱最多添加{pop_email_max}個';  //WM_POP_EMAILCOUNT_MAX_ERROR
  errorMsg["n2553"] = '郵箱格式不正確';  //WM_POP_EMAIL_FORMAT_ERROR
  errorMsg["n2554"] = 'POP郵箱帳號驗證失敗！ 請檢查設定';  //WM_POP_AUTH_ERROR
  errorMsg["n2555"] = '存放至文件夹不存在';  //WM_POP_FOLDER_ERROR
  errorMsg["n2556"] = 'POP郵箱帳號驗證失敗！ 請檢查設定';  //WM_POP_RETR_ERROR
  errorMsg["n2601"] = '郵箱格式有誤，示例： name@example.com ';  //WM_DELIVER_EMAIL_ERROR
  errorMsg["n2602"] = '自動轉發與回復設定發禁止修改，如有問題請及時聯系管理員';  //WM_DELIVER_DISABLE_ERROR
  errorMsg["n2603"] = '禁止轉發到外域';  //WM_DELIVER_FOREIGN_ERROR
  errorMsg["n2604"] = '自動轉發地址最多可添加{forward_addr_max}個';  //WM_DELIVER_ADDRMAX_ERROR
  errorMsg["n2605"] = '禁止添加自己的郵箱';  //WM_DELIVER_FORWARDADDR_ERROR
  errorMsg["n2651"] = '分類過濾規則最多可添加{filter_rule_max}個';  //WM_FILTER_MAXCOUNT_ERROR
  errorMsg["n2652"] = '分類過濾規則名字已存在';  //WM_FILTER_NAMESAME_ERROR
  errorMsg["n2653"] = '指定文件夹不存在';  //WM_FILTER_FOLDER_ERROR
  errorMsg["n2654"] = '發件人最多可添加{filter_member_max}個';  //WM_FILTER_FROM_MEMBER_ERROR
  errorMsg["n2655"] = '收件人最多可添加{filter_member_max}個';  //WM_FILTER_TO_MEMBER_ERROR
  errorMsg["n2701"] = '文件不存在';  //WM_LARGE_FILE_NOT_FOUND_ERROR
  errorMsg["n2751"] = '郵件审核已完成';  //WM_AUDIT_MAIL_STATUS_FINISH
  errorMsg["n2801"] = '文件夹名稱長度超出限制';  //WM_FOLDER_NAME_MAX_LIMIT
  errorMsg["n2802"] = '可能存在同名文件夹';  //WM_FOLDER_UNIQ_KEY_ERROR
  errorMsg["n2851"] = '郵件日發送數量超限';  //WM_SMTP_512_1
  errorMsg["n2852"] = '發件人在收件人{invalidAddress}的黑名單中';  //WM_SMTP_512_2
  errorMsg["n2853"] = '禁止向無許可權的郵寄列表發信';  //WM_SMTP_513
  errorMsg["n2854"] = '發件人在{invalidAddress}黑名單中';  //WM_SMTP_515
  errorMsg["n2855"] = '域或用戶被禁用';  //WM_SMTP_535
  errorMsg["n2856"] = '用戶{invalidAddress}不存在';  //WM_SMTP_550_1
  errorMsg["n2857"] = '用戶{invalidAddress}已鎖定';  //WM_SMTP_550_2
  errorMsg["n2858"] = '禁止發送郵件';  //WM_SMTP_552
  errorMsg["n2859"] = '禁止發送到外域郵箱{invalidAddress}';  //WM_SMTP_554
  errorMsg["n2860"] = '禁止發送到指定域或用戶{invalidAddress}';  //WM_SMTP_555
  errorMsg["n2861"] = '不允許發送到以下地址{invalidAddress}';  //WM_SMTP_556
  errorMsg["n2862"] = '收件人數量超限';  //WM_SMTP_557
  errorMsg["n2863"] = '{invalidAddress}禁止接收外域郵箱發來的郵件';  //WM_SMTP_558
  errorMsg["n2864"] = '郵件大小超過角色上限';  //WM_SMTP_559_1
  errorMsg["n2865"] = '郵件大小超過系統上限';  //WM_SMTP_559_2
  errorMsg["n2866"] = '用戶{invalidAddress}郵箱容量超限';  //WM_SMTP_573
  errorMsg["n2867"] = '主題或內容中包含關鍵字，禁止發送';  //WM_SMTP_598
  errorMsg["n2868"] = '疑似釣魚郵件，禁止發送';  //WM_SMTP_599
  errorMsg["n2869"] = 'IP併發連接數超限:{invalidAddress}';  //WM_SMTP_591
  errorMsg["n2870"] = 'IP連接頻率超限:{invalidAddress}';  //WM_SMTP_592
  errorMsg["n2871"] = 'IP發信頻率超限:{invalidAddress}';  //WM_SMTP_593
  errorMsg["n2872"] = 'Sender併發連接數超限:{invalidAddress}';  //WM_SMTP_594
  errorMsg["n2873"] = 'Sender發信頻率超限:{invalidAddress}';  //WM_SMTP_595
  errorMsg["n2874"] = 'Rejected,ip in blacklist:{invalidAddress}';  //WM_SMTP_516
  errorMsg["n2875"] = 'Rejected,sender in blacklist: {invalidAddress}';  //WM_SMTP_517
  errorMsg["n2876"] = 'Rejected,domain in blacklist: {invalidAddress}';  //WM_SMTP_518
  errorMsg["n2877"] = 'ip in spamhaus blacklist';
  errorMsg["n2901"] = '信任地最多可添加{trust_location_manual_max}個';  //WM_TRUST_LOCATION_MAX_ERROR
  errorMsg["n2902"] = '此手機號碼綁定郵箱個數已達上限';  //WM_BIND_PHONE_MAX_ERROR
  errorMsg["n2903"] = '當前用戶未綁定此手機號';  //WM_SAFE_LOGIN_BIND_INFO_NOT_EXSIT
  errorMsg["n3001"] = '無許可權';  //UDCD_PERMISSION_DENIED
  errorMsg["n3002"] = '認證失敗';  //UDCD_AUTHENTICATION_ERROR
  errorMsg["n3101"] = '客戶不存在';  //UDR_CORP_NOT_FOUND
  errorMsg["n3102"] = '客戶已被禁用';  //UDR_CORP_FORBIDDEN
  errorMsg["n3106"] = '企業已被禁用';  //UDR_MAIL_CORP_FORBIDDEN
  errorMsg["n3107"] = '用戶已被禁用';  //UDR_MAIL_ACCOUNT_FORBIDDEN
  errorMsg["n3108"] = '介面ID不存在或金鑰錯誤';  //UDR_API_USER_NOT_FOUND
  errorMsg["n3109"] = '該應用已被禁用';  //UDR_API_USER_FORBIDDEN
  errorMsg["n3110"] = '不允許該ip登入';  //UDR_API_IP_ERROR
  errorMsg["n3111"] = '不允許Web登入';  //UDR_API_WEB_ERROR
  errorMsg["n3112"] = '重繪token不存在';  //UDR_REFRESH_TOKEN_ERROR
  errorMsg["n3113"] = '用戶名或密碼錯誤';  //UDR_USER_PASSWORD_ERROR
  errorMsg["n3114"] = '用戶名密碼錯誤次數過多，已被臨時鎖定，請稍後再試或聯系管理員修改密碼';  //UDR_USER_PASSWORD_LOCK_ERROR
  errorMsg["n3115"] = '用戶首次修改密碼';  //UDR_USER_PASSWORD_FIRST_ERROR
  errorMsg["n3116"] = '用戶定期修改密碼';  //UDR_USER_PASSWORD_CYCLE_ERROR
  errorMsg["n3117"] = '新密碼過於簡單，請重新輸入';  //UDR_USER_PASSWORD_WEAK_ERROR
  errorMsg["n3118"] = '登入IP被限制';  //UDR_USER_IP_LIMITED_ERROR
  errorMsg["n3119"] = '登入時間被限制';  //UDR_USER_TIME_LIMITED_ERROR
  errorMsg["n3120"] = '登入成功';  //UDR_USER_LOGIN_SUCCESS
  errorMsg["n3121"] = '企業不存在';  //UDR_CORP_NOT_EXIST
  errorMsg["n3122"] = '企業已被删除';  //UDR_CORP_STATUS_ERROR
  errorMsg["n3123"] = '企業已到期';  //UDR_CORP_EXPIRE_ERROR
  errorMsg["n3124"] = '只允許ssl登入';  //UDR_API_SSL_ERROR
  errorMsg["n3125"] = '不允許POP登入';  //UDR_API_POP_ERROR
  errorMsg["n3126"] = '不允許IMAP登入';  //UDR_API_IMAP_ERROR
  errorMsg["n3127"] = '不允許SMTP登入';  //UDR_API_SMTP_ERROR
  errorMsg["n3128"] = '用戶端授權碼認證失敗';  //UDR_USER_AUTHCODE_ERROR
  errorMsg["n3129"] = '管理員已被禁用';  //UDR_MANAGER_FORBIDDEN
  errorMsg["n3141"] = '企業ID不存在';  //UDR_CORP_ID_NOT_FOUND
  errorMsg["n3142"] = '域名ID不存在';  //UDR_DOMIAN_ID_NOT_FOUND
  errorMsg["n3143"] = '域名不存在';  //UDR_DOMIAN_NOT_FOUND
  errorMsg["n3144"] = '用戶ID不存在';  //UDR_USER_ID_NOT_FOUND
  errorMsg["n3145"] = '用戶不存在';  //UDR_USER_EMAIL_NOT_FOUND
  errorMsg["n3146"] = '郵箱帳號ID不存在';  //UDR_MAIL_ACCOUNT_ID_NOT_FOUND
  errorMsg["n3147"] = '郵箱不存在';  //UDR_MAIL_ACCOUNT_EMAIL_NOT_FOUND
  errorMsg["n3148"] = '地址不存在';  //UDR_MEMBER_SELECTOR_ID_NOT_FOUND
  errorMsg["n3149"] = '用戶名或密碼錯誤';  //UDR_PWD_DECRYPT_ERROR
  errorMsg["n3150"] = '登入地區被限制';  //UDR_USER_LOCATION_LIMITED_ERROR
  errorMsg["n4001"] = '未獲取到卷信息';  //FS_VOLUME_INFO_NOT_FOUND
  errorMsg["n4010"] = '未發現文件';  //FS_FILE_NOT_FOUND
  errorMsg["n4014"] = '';  //FS_FILE_MIME_NOT_FOUND
  errorMsg["n4021"] = '您查看的郵件已不存在';  //FS_FILE_GET_FAIL
  errorMsg["n4023"] = '獲取文件指定偏移量及長度無效';  //FS_FILE_GET_INVALID_POS_SIZE
  errorMsg["n4031"] = '保存文件失敗';  //FS_FILE_SAVE_FAIL
  errorMsg["n4032"] = '保存文件已經存在';  //FS_FILE_SAVE_EXIST
  errorMsg["n4033"] = '文件上傳失敗';  //FS_FILE_UPLOAD_FAIL
  errorMsg["n4034"] = '文件上傳分片校驗失敗';  //FS_FILE_UPLOAD_CHUNK_CHECK_FAIL
  errorMsg["n4037"] = '對不起，您訪問的链接已經過期或者失效！';  //FS_FILE_DOWNLOAD_FAIL
  errorMsg["n4041"] = '存儲文件沒有發現頭信息';  //FS_FILE_HEAD_NOT_FOUND
  errorMsg["n4042"] = '存儲文件頭信息無效';  //FS_FILE_HEAD_INVALID
  errorMsg["n4053"] = '存儲文件分片長度無效';  //FS_FILE_CHUNK_SIZE_INVALID
  errorMsg["n4101"] = '獲取信頭失敗';  //MS_GET_MAIL_HEADER
  errorMsg["n4102"] = '企業無效';  //MS_CORP_INVALID
  errorMsg["n4103"] = '企業ID無效';  //MS_CORP_ID_INVALID
  errorMsg["n4104"] = '企業存在';  //MS_CORP_EXIST
  errorMsg["n4105"] = '郵箱帳號無效';  //MS_MAIL_ACCOUNT_INVALID
  errorMsg["n4106"] = '郵箱帳號ID無效';  //MS_MAIL_ACCOUNT_ID_INVALID
  errorMsg["n4107"] = '郵箱帳號存在';  //MS_MAIL_ACCOUNT_EXIST
  errorMsg["n4111"] = '文件夹無效';  //MS_FOLDER_INVALID
  errorMsg["n4112"] = '文件夹ID無效';  //MS_FOLDER_ID_INVALID
  errorMsg["n4113"] = '存在同名文件夹';  //MS_FOLDER_EXIST
  errorMsg["n4114"] = '文件夹不存在';  //MS_FOLDER_NOT_EXIST
  errorMsg["n4115"] = '無效的父文件夹';  //MS_FOLDER_INVALID_PARENT
  errorMsg["n4116"] = '文件夹空間佔用標記不一致';  //MS_FOLDER_DATA_INVALID
  errorMsg["n4121"] = '文件夹層級超限';  //MS_FOLDER_DEPTH_MAX_LIMIT
  errorMsg["n4122"] = '文件夹數量超限';  //MS_FOLDER_COUNT_MAX_LIMIT
  errorMsg["n4131"] = '不能修改系統文件夹';  //MS_FOLDER_DENY_CHANGE_SYS_FOLDER
  errorMsg["n4132"] = '不能在已備份文件夹中創建文件夹';  //MS_FOLDER_BACKUP_CREATE_SUBFOLDER
  errorMsg["n4133"] = '不能删除系統文件夹';  //MS_FOLDER_DENY_DEL_SYS_FOLDER
  errorMsg["n4134"] = '文件夹內存在郵件，故不能删除';  //MS_FOLDER_DENY_DEL_MAIL_EXIST
  errorMsg["n4135"] = '文件夹存在子文件夹，故不能删除';  //MS_FOLDER_DENY_DEL_SUBFOLDER_EXISTED
  errorMsg["n4201"] = '郵件索引處理失敗';  //MS_INDEX_PROC_FAIL
  errorMsg["n4202"] = '郵件索引無效';  //MS_INDEX_INVALID
  errorMsg["n4203"] = '郵件索引ID無效';  //MS_INDEX_ID_INVALID
  errorMsg["n4204"] = '郵件索引未發現';  //MS_INDEX_NOT_FOUND
  errorMsg["n4221"] = '郵箱容量超限';  //MS_INDEX_OVER_SPACE_LIMIT
  errorMsg["n4222"] = '用戶郵箱封數超容';  //MS_INDEX_OVER_NUM_LIMIT
  errorMsg["n4231"] = '密碼驗證失敗';  //MS_INDEX_VERIFY_PASSWORD_FAIL
  errorMsg["n5001"] = '短信發送失敗';  //NOTIFIER_SMS_SEND_FAIL
  errorMsg["n5002"] = '短信範本不存在';  //NOTIFIER_SMS_TEMPLATE_NOT_FOUND
  errorMsg["n5003"] = '驗證碼無效或已過期';  //NOTIFIER_CODE_ERROR
  errorMsg["n5004"] = '驗證碼不能為空';  //NOTIFIER_CAN_NOT_NULL
  errorMsg["n5005"] = '獲取驗證碼過於頻繁';  //NOTIFIER_CODE_LIMIT_ERROR
  errorMsg["n5006"] = '目前短信管道擁堵，請稍後再試！';  //NOTIFIER_MD_SERVER_ERROR
  errorMsg["n5007"] = '漫道發送短信失敗';  //NOTIFIER_MD_SEND_ERROR
  errorMsg["n5008"] = '當日獲取驗證碼次數已達上限';  //NOTIFIER_CODE_DAY_LIMIT_ERROR
  errorMsg["n6001"] = '調用ms失敗';  //SCHEDULE_FEIGN_MS_FAIL
  errorMsg["n7001"] = '組裝消息內容失敗';  //PUSH_MESSAGE_BUILDMSG_ERROR
  errorMsg["n9001"] = '系統配寘信息异常';  //SYSTEM_CONFIG_INFO_ERROR
  errorMsg["n9100"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFO
  errorMsg["n9101"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_LICENSE
  errorMsg["n9102"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_BOSS_CONTRACTS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9103"] = '未査詢到有效的許可證文件';  //LICENSE_JSON_DEVICE_INFOS
  errorMsg["n9180"] = '許可證導入失敗';  //LICENSE_IMPORT_ERROR
  errorMsg["n9199"] = '許可證失敗';  //LICENSE_UNKNOWN_ERROR
  errorMsg["n9200"] = '認證失敗';  //UMT_AUTH_ERR
  errorMsg["n9201"] = '參數失敗';  //UMT_PARAMETER_ERR
  errorMsg["n9203"] = 'acl异常';  //UMT_ACL_ERR
  errorMsg["n9204"] = '査詢文件夹失敗';  //UMT_LIST_FOLDER_ERR
  errorMsg["n9205"] = '添加文件夹异常';  //UMT_ADD_FOLDER_ERR
  errorMsg["n9206"] = 'ms存信异常';  //UMT_SAVE_EMAIL_ERR
  errorMsg["n9207"] = 'imap异常';  //UMT_IMAP_ERR
  errorMsg["n9217"] = 'pop异常';  //UMT_POP_ERR
  errorMsg["n9299"] = '搬家异常';  //UMT_UNKNOWN_ERROR
  errorMsg["n9301"] = 'IP in blacklist:{ip}';  //MIDS_IP_BLACKLIST
  errorMsg["n9302"] = 'IP locked:{ip}';  //MIDS_IP_PRISON
  errorMsg["n9303"] = 'User locked:{email}';  //MIDS_ACCOUNT_PRISON
  errorMsg["n-100"] = '參數錯誤';  //MIGRATE_ERROR_PARAMERROR
  errorMsg["n-101"] = '測試帳號驗證失敗，請檢查服務器信息和測試帳號及密碼';  //MIGRATE_ERROR_PASSWDERROR
  errorMsg["n-102"] = '網絡錯誤';  //MIGRATE_ERR_OR_NETERROR
  errorMsg["n9999"] = '功能尚未支持，敬請期待！';  //UN_SUPPORT
  errorMsg["n10000"] = 'last error';  //LAST_ERROR

  return function (errorCode) {
    let code = errorCode;
    let msgVals = undefined;
    if ('object' === typeof errorCode) {
      code = errorCode.code;
      msgVals = errorCode.msgVals;
    }

    let msg = errorMsg["n" + code];
    if (typeof msg === "undefined") {
      msg = errorMsg["n1000"];
    }

    if ('object' === typeof msgVals) {
      for (let key in msgVals) {
        if (key === 'undo_time_limit') {
          let num_unit = parseInt(msgVals[key]) < 24 ? parseInt(msgVals[key]) + '小时' : parseInt(msgVals[key]) / 24 + '天';
          msg = msg.replace(new RegExp('\\{' + key + '\\}', 'g'), num_unit);
        } else {
          msg = msg.replace(new RegExp('\\{' + key + '\\}', 'g'), msgVals[key])
        }
      }
    }

    return msg;
  }

})();

export default getErrorMsg;



// WEBPACK FOOTER //
// ./src/language/hkErrorMessage.js